import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SubdomainService } from './subdomain.service';

export interface DashboardStats {
  totalAssessments: number;
  totalCollection: number;
  totalWards: number;
  activeUsers: number;
  assessmentGrowth: number;
  collectionGrowth: number;
  userGrowth: number;
}

export interface MonthlyStats {
  newAssessments: number;
  monthlyCollection: number;
  completedTasks: number;
  monthPeriod?: string;
  startDate?: string;
  endDate?: string;
}

export interface Activity {
  id: string;
  type: string;
  icon: string;
  description: string;
  timestamp: Date;
}

export interface WardStats {
  ward_number: number;
  assessment_count: number;
}

export interface ChartData {
  month: string;
  assessments: number;
  collection: number;
}

export interface DashboardResponse {
  dashboardStats: DashboardStats;
  monthlyStats: MonthlyStats;
  recentActivities: Activity[];
  wardStats: WardStats[];
}

export interface ChartDataResponse {
  chartData: ChartData[];
}

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private apiUrl = `${environment.apiBaseUrl}/api/dashboard`;

  constructor(
    private http: HttpClient,
    private subdomainService: SubdomainService
  ) { }

  /**
   * Get dashboard statistics
   */
  getDashboardStats(monthPeriod?: string): Observable<DashboardResponse> {
    const body = {
      subdomain: this.subdomainService.getSubdomain(),
      monthPeriod: monthPeriod || 'THIS_MONTH'
    };
    return this.http.post<DashboardResponse>(`${this.apiUrl}/stats`, body);
  }

  /**
   * Get monthly chart data
   */
  getMonthlyChartData(months: number = 6): Observable<ChartDataResponse> {
    const body = {
      subdomain: this.subdomainService.getSubdomain(),
      months
    };
    return this.http.post<ChartDataResponse>(`${this.apiUrl}/monthly-chart`, body);
  }

  /**
   * Refresh dashboard data
   */
  refreshDashboard(): Observable<DashboardResponse> {
    return this.getDashboardStats();
  }
} 